import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import vendor1099ReportTemplate from './vendor1099Report.template.html';

export default angular
  .module('books.ui.vendor1099Report', [csmCommonWeb, booksService])
  .directive('vendor1099Report', vendor1099ReportDirective).name;

/* @ngInject */
function vendor1099ReportDirective(BooksSvc, BusyScreen) {
  return {
    template: vendor1099ReportTemplate,
    link: function ($scope, element, attr) {
      /*------------------------------------------------*/
      /* Sets the default report format to PDF and the  */
      /* sorting of the report to be set to sortByTaxID */
      /*------------------------------------------------*/
      $scope.req = { reportFormat: 'PDF', sortByTaxID: false };

      /*-------------------------*/
      /* Sets the default action */
      /*-------------------------*/
      // TODO: Seems like we could have a more secure way of handling this by having 
      // TODO: a map on the server for the locations.
      $scope.data = { reportHandler: 'Vendors1099SummaryReport.aspx' };

      /*--------------------------------------------------------*/
      /* Works with the CSMValidator and checks to make sure    */
      /* that the start date and end date fields are populated. */
      /*--------------------------------------------------------*/
      $scope.valDate = {};
      $scope.validateInput = function () {
        return $scope.valDate.validate();
      };

      /*****************************************************************************
       * getOrganization */
      /**
       * Returns current organization information.
       *****************************************************************************/
      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;
        BusyScreen.setBusy(false);
      });
    }
  };
}
